import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import WarningModal from 'shared/lib/components/modals/warningModal';
import { useTranslation } from 'react-i18next';
import { ModalProps } from 'shared/lib/components/modals/modal';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import { trashApi } from 'entities/trash/api/trashApi';

export type FinallyDeleteFolderAfterReactions = {
  afterFolderFinallyDelete?: (id: string) => void;
};

export default observer(function FinallyDeleteFolderModalController({
  id,
  afterFolderFinallyDelete,
  handleClose,
}: {
  id: string;
} & FinallyDeleteFolderAfterReactions & {
    handleClose: ModalProps['handleClose'];
  }) {
  const { mobxStore } = useContext(MobxContext);
  const { t } = useTranslation();

  return (
    <>
      <WarningModal
        mainText={t('warnings.finallyDelete.folderMain')}
        secondText={t('warnings.finallyDelete.folderSecond')}
        isOpen={true}
        onCancel={handleClose}
        onContinue={async () => {
          try {
            await trashApi.deleteFolder(id);
            afterFolderFinallyDelete && afterFolderFinallyDelete(id);
            handleClose();
          } catch (e) {
            mobxStore.notificationsStore.errorMessage = t(
              'notifications.errors.default'
            );
            console.error(e);
            handleClose();
          }
        }}
      ></WarningModal>
    </>
  );
});
